import React, {
  FC, useCallback, useEffect, useMemo, useState,
} from 'react';

import { AffectedQuestions } from '../../commons/AffectedQuestions';
import { QBackButton } from '../../commons/QBackButton';
import { QConfirmButton } from '../../commons/QConfirmButton';
import { QHeader } from '../../commons/QHeader';

import { Q17Form, Q17Response } from './form';
import { Row } from 'components/base/Row';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { Address } from 'modules/budget/models/Address';
import { isBooleanAndFalse, isBooleanAndTrue } from 'utils/helpers';

export const Q17: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q17;
  const { RespondQuestion } = useBudget();

  const [dimissService, setDimissService] = useState<boolean>();
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);
  const [autorespond, setautorespond] = useState<boolean>(false);

  const canRespond = useMemo(
    () => isBooleanAndTrue(dimissService)
      || (isBooleanAndFalse(dimissService) && (selectedAddress?.isFullFilled() || false)),
    [dimissService, selectedAddress],
  );

  const response = useCallback(
    ({ gotoSummary }) => {
      if (!dimissService) {
        if (selectedAddress) {
          RespondQuestion({
            gotoSummary,
            question,
            response: {
              address: selectedAddress,
            },
          });
        }
      } else {
        RespondQuestion({
          gotoSummary,
          question,
        });
      }
    },
    [RespondQuestion, dimissService, question, selectedAddress],
  );

  const onChange = useCallback(
    (responseData: Q17Response) => {
      setSelectedAddress(responseData.address);
      setDimissService(Boolean(responseData.dismissService));
      setautorespond(responseData.autorespond);
    },
    [],
  );

  useEffect(
    () => {
      if (autorespond && canRespond) {
        setautorespond(false);
        response({ gotoSummary: false });
      }
    },
    [autorespond, canRespond, response],
  );

  return (
    <React.Fragment>
      <QHeader question={question} />
      <Q17Form
        question={question}
        onChange={onChange}
      />
      <Row justifyContent="space-between">
        <QBackButton question={question} />
        <Row
          className="f-question-actions"
          justifyContent="flex-end"
        >
          <AffectedQuestions
            question={question}
            response={{
              address: selectedAddress,
            }}
          />
          <QConfirmButton
            disabled={!canRespond}
            question={question}
            onClick={(payload) => response({ gotoSummary: payload?.gotoSummary })}
          />
        </Row>
      </Row>
    </React.Fragment>
  );
};
